<template>
    <div>
        <ToolBar
            :menu="'Tiếp nhận dữ liệu QLNT'"
            :content="'Cấu hình lịch đồng bộ'"
            :subContent="'Cấu hình lịch đồng bộ cấp Trường'"
        >
        </ToolBar>
        <FormSearch :column-form="2" :on-enter-search="handleSearch">
            <div class="row">
                <div class="col-md-3">
                    <label>Phường/Xã</label>
                    <ESelect
                        :disabled="isRoleEducationOfficeOrSchool"
                        :data="list_ward"
                        :multiple="true"
                        :fields="['tenPhuongXa', 'maPhuongXa']"
                        v-model="ward"
                        @change="onChangeWard"
                    />
                </div>

                <div class="col-md-3">
                    <label>Trường học</label>
                    <ESelect
                        :disabled="isRoleSchool"
                        :data="list_school"
                        :multiple="true"
                        :fields="['tenTruongHoc', 'maTruongHoc']"
                        v-model="school"
                    />
                </div>

                <div class="col-md-3">
                    <label>Trạng thái</label>
                    <ESelect
                        :data="list_status"
                        :fields="['label', 'value']"
                        v-model="status"
                    />
                </div>

                <div class="col-md-3" style="display: flex; align-items: flex-end;">
                    <CustomButton label="Tìm kiếm" @click="handleSearch" />
                </div>
            </div>
        </FormSearch>
        <CustomTable
            :column-form="2"
            :hide-btn-table="true"
            :title="'Cấu hình năm học cấp trường'"
        >
            <template v-slot:title-actions>
                <span class="count" v-if="isCheckedCount > 0">
                    <b>Đã chọn {{ isCheckedCount }} bản ghi</b>
                </span>
                <CustomButton 
                    v-if="isCheckedCount > 0"
                    label="Khóa" 
                    @click="openModalStatusAll(0)" 
                    :plain="true" 
                />
                <CustomButton 
                    v-if="isCheckedCount > 0"
                    label="Mở khóa" 
                    @click="openModalStatusAll(1)" 
                    :plain="true" 
                />
                <CustomButton 
                    v-if="isCheckedCount > 0"
                    label="Chỉnh sửa" 
                    @click="openModalUpdateAll" 
                    :plain="true" 
                />
                <CustomButton label="Thêm mới" @click="openModalAddNew" />

            </template>
            <template v-slot:header>
                <tr>
                    <th>
                        <input
                            type="checkbox"
                            v-model="selectAllChecked"
                            @change="handleSelectAllCheckbox"
                            :disabled="tableData.length === 0"
                            class="select-all-checkbox"
                        />
                    </th>
                    <th>STT</th>
                    <th>Mã trường</th>
                    <th>Tên trường</th>
                    <th>Ngày bắt đầu</th>
                    <th>Ngày kết thúc</th>
                    <th>Trạng thái</th>

                    <th>Thao tác</th>
                </tr>
            </template>
            <template v-slot:body>
                <tr v-for="(item, index) in tableData" :key="index">
                    <td class="text-tbody">
                        <input
                            type="checkbox"
                            :checked="item.isChecked"
                            @change="toggleCheckbox(item)"
                            class="select-all-checkbox"
                            />
                    </td>
                    <td>
                        {{ (currentPage - 1) * limit + index + 1 }}
                    </td>

                    <td class="text-left">{{ item.maTruongHoc }}</td>

                    <td class="text-left">{{ item.tenTruongHoc }}</td>
                    <td>
                        {{ item.tuNgay }}
                    </td>
                    <td>
                        {{ item.denNgay }}
                    </td>
                    <td>
                        <TextStatus
                            :content="
                                item.status === 1
                                    ? 'Đang hoạt động'
                                    : 'Ngưng hoạt động'
                            "
                            :status="item.status"
                        />
                    </td>
                    <td>
                        <span v-if="item.status === 1">
                            <CustomToolTip content="Khóa">
                                <img
                                    :src="iconLock"
                                    class="icon"
                                    @click="
                                        openModalStatusOne(item.maTruongHoc, 0)
                                    "
                                />
                            </CustomToolTip>
                        </span>
                        <span v-else>
                            <CustomToolTip content="Mở khóa">
                                <img
                                    :src="iconUnLock"
                                    class="icon"
                                    @click="
                                        openModalStatusOne(item.maTruongHoc, 1)
                                    "
                                />
                            </CustomToolTip>
                        </span>
                        <span>
                            <CustomToolTip content="Chỉnh sửa">
                                <img
                                    :src="iconEdit"
                                    class="icon"
                                    @click="openModalUpdateOne(item.maTruongHoc)"
                                /> </CustomToolTip
                        ></span>
                    </td>
                </tr>
            </template>
            <template v-slot:pagi>
                <CustomPagination
                    v-show="total_rows > 0"
                    :tongbanghi="total_rows"
                    :pageSize="pageSize"
                    :pageStart="pageStart"
                    @pageChange="pageChange($event)"
                    @pageSizeChange="pageSizeChange($event)"
                >
                </CustomPagination>
            </template>
        </CustomTable>

        <ModalAddNew
            :closeModalAddNew="closeModalAddNew"
            :addNewVisible="addNewVisible"
            @handleSearch="handleSearch"
        />
        <ModalStatus
            :closeModalStatus="closeModalStatus"
            :statusVisible="statusVisible"
            @handleSearch="handleSearch"
            :dataStatus="dataStatus"
            :statusUpdate="statusUpdate"
        />
        <ModalUpdate
            :closeModalUpdate="closeModalUpdate"
            :updateVisible="updateVisible"
            @handleSearch="handleSearch"
            :dataUpdate="dataUpdate"
        />
    </div>
</template>

<script>
import CustomToolTip from '@/components/CustomToolTip.vue'
import FormSearch from '@/components/FormSearch.vue'
import ToolBar from '@/components/ToolBar.vue'
import CustomButton from '@/components/CustomButton.vue'
import ESelect from '@/components/ESelect.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import { countCheckedItems } from '@/utils'
import CustomTable from '@/components/CustomTable.vue'
import ModalAddNew from './modal_add.vue'
import ModalStatus from './modal_status.vue'
import ModalUpdate from './modal_update.vue'
import CustomPagination from '@/components/CustomPagination.vue'
import iconEdit from '@/assets/img/icon-table/edit.svg'
import iconLock from '@/assets/img/icon-table/lock.svg'
import iconUnLock from '@/assets/img/icon-table/un-lock.svg'
import TextStatus from '@/components/TextStatus.vue'
import { ROLES, checkUserRole } from '@/constants/Roles'
import { showNotication } from '@/utils/notification'

export default {
    name: 'SchoolLevel',
    components: {
        FormSearch,
        ToolBar,
        CustomButton,
        ESelect,
        CustomTable,
        ModalAddNew,
        ModalStatus,
        ModalUpdate,
        CustomPagination,
        CustomToolTip,
        TextStatus
    },
    data() {
        return {
            iconEdit,
            iconLock,
            iconUnLock,

            start: 0,
            total_rows: 0,
            currentPage: 1,
            limit: 25,
            pageSize: 25,
            pageStart: false,

            selectAllChecked: false,

            unit_education: [],

            list_ward: [],
            ward: [],
            list_school: [],
            school: [],
            list_status: [
                {
                    label: 'Đang hoạt động',
                    value: '1'
                },
                {
                    label: 'Ngừng hoạt động',
                    value: '0'
                }
            ],
            status: '',

            tableData: [],
            isCheckedCount: 0,
            addNewVisible: false,

            statusVisible: false,
            dataStatus: [],
            statusUpdate: 0,

            updateVisible: false,
            dataUpdate: []
        }
    },

    methods: {
        pageSizeChange(e) {
            this.pageSize = e.soluong
            this.limit = e.soluong
            this.start = 0
            this.currentPage = 1
            this.handleSearch()
        },
        checkTruocKhiTim() {
            this.pageStart = !this.pageStart
        },
        pageChange(e) {
            this.start = e.start
            this.limit = e.limit
            this.currentPage = e.currentPage
            this.handleSearch()
        },

        openModalAddNew() {
            this.addNewVisible = true
        },
        closeModalAddNew() {
            this.addNewVisible = false
        },
        openModalStatusAll(status) {
            const dataStatusAll = this.tableData.filter((item) => item.isChecked)
            if (dataStatusAll.length === 0) {
                showNotication(this, 'error', 'Vui lòng chọn bản ghi')
                return
            }
            this.statusUpdate = status
            this.dataStatus = dataStatusAll
            this.statusVisible = true
        },
        openModalStatusOne(maTruongHoc, status) {
            this.tableData.forEach((item) => {
                item.isChecked = false
            })
            this.selectAllChecked = false
            const dataStatusOne = this.tableData.filter(
                (item) => item.maTruongHoc === maTruongHoc
            )
            dataStatusOne.forEach((item) => {
                item.isChecked = true
            })
            this.statusUpdate = status
            this.statusVisible = true
            this.dataStatus = dataStatusOne
        },
        closeModalStatus() {
            if (this.dataStatus) {
                this.dataStatus.forEach((item) => {
                    item.isChecked = false
                })
            }
            this.selectAllChecked = false
            this.statusVisible = false
        },
        openModalUpdateAll() {
            const dataUpdateAll = this.tableData.filter((item) => item.isChecked)
            if (dataUpdateAll.length === 0) {
                showNotication(this, 'error', 'Vui lòng chọn bản ghi')
                return
            }
            this.dataUpdate = dataUpdateAll
            this.updateVisible = true
        },
        openModalUpdateOne(maTruongHoc) {
            this.tableData.forEach((item) => {
                item.isChecked = false
            })
            this.selectAllChecked = false
            const dataUpdateOne = this.tableData.filter(
                (item) => item.maTruongHoc === maTruongHoc
            )
            dataUpdateOne.forEach((item) => {
                item.isChecked = true
            })

            this.updateVisible = true
            this.dataUpdate = dataUpdateOne
        },
        closeModalUpdate() {
            if (this.dataUpdate) {
                this.dataUpdate.forEach((item) => {
                    item.isChecked = false
                })
            }
            this.selectAllChecked = false
            this.updateVisible = false
        },

        async get_list_ward() {
            try {
                const request_data = {
                    start: 0,
                    limit: 9999,
                    maTinhThanh: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }

                const response = await sendRequest(
                    Api.app.phuong_xa,
                    null, // GET request uses params, not data
                    this.request_headers,
                    request_data // params for GET request
                )

                this.list_ward = response.rows || []
                
                // After loading wards, pre-select based on ma_don_vi if applicable
                if (this.isRoleEducationOfficeOrSchool && this.auth_user?.ma_don_vi) {
                    this.preselectWardFromMaDonVi(this.auth_user.ma_don_vi)
                }
            } catch (error) {
                console.log(error)
                this.list_ward = []
            }
        },
        
        /**
         * Pre-select ward based on ma_don_vi
         */
        preselectWardFromMaDonVi(ma_don_vi) {
            if (!ma_don_vi || !this.list_ward || this.list_ward.length === 0) {
                return
            }
            
            // Find ward where maPhuongXa matches ma_don_vi
            const foundWard = this.list_ward.find(
                (ward) => ward.maPhuongXa === ma_don_vi || ward.maPhuongXa === String(ma_don_vi)
            )
            
            if (foundWard) {
                // Pre-select the ward (as array since it's multiple select)
                this.ward = [foundWard.maPhuongXa]
                // Trigger school list update if ward is pre-selected
                this.get_list_school()
            }
        },

        onChangeWard() {
            this.school = []
            this.get_list_school()
        },

        async get_list_school() {
            this.school = []

            const request_data = {
                capHoc: this.selectedGradeLevelFromStore,
                namHoc: this.selectedYearFromStore,
                maPhuongXaList: this.ward || []
            }

            const response = await sendRequest(
                Api.internal_api.dm_School,
                request_data,
                this.request_headers,
                null
            )
            this.list_school = response.rows.map((item) => ({
                ...item,
                tenTruongHoc: `${item.tenTruongHoc} - [${item.maTruongHoc}]`
            }))
        },
        toggleCheckbox(item) {
            this.selectAllChecked = false
            item.isChecked = !item.isChecked
        },
        handleSelectAllCheckbox() {
            this.tableData.forEach((item) => {
                item.isChecked = this.selectAllChecked
            })
        },

        async handleSearch() {
            try {
                const request_data = {
                    dsCapHoc: this.selectedGradeLevelFromStore,
                    dsMaDonVi: this.ward || [],
                    dsMaTruong: this.school || [],
                    maSo: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore,
                    status: this.status,
                    start: this.start,
                    limit: this.limit
                }

                const response = await sendRequest(
                    Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo.cap_truong,
                    request_data,
                    this.request_headers,
                    null
                )

                // if (response.rc == 0) {
                //     showNotication(this, 'success', response.rd)
                // } else if (response.rc == 2) {
                //     showNotication(this, 'error', response.rd)
                // }
                this.total_rows = response.totalRows

                this.tableData = response.tableData.map((item) => {
                    return { ...item, isChecked: false }
                })
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {
        this.get_list_ward()
        this.get_list_school()
        this.handleSearch()
    },
    watch: {
        selectedYearFromStore: function (newVal) {
            if (newVal) {
                this.ward = []
                this.get_list_ward()
            }
        },

        selectedGradeLevelFromStore: function (newVal) {
            if (newVal) {
                this.school = []
                this.get_list_school()
            }
        },

        tableData: {
            handler(newVal) {
                this.isCheckedCount = countCheckedItems(newVal)
            },
            deep: true
        },

        auth_user: {
            handler(user) {
                if (this.isRoleEducationOfficeOrSchool) {
                    this.unit_education = user.ma_phong ? [user.ma_phong] : []
                    // Pre-select ward based on ma_don_vi
                    this.preselectWardFromMaDonVi(user.ma_don_vi)
                }
                if (this.isRoleSchool) {
                    this.school = user.ma_truong_hoc ? [user.ma_truong_hoc] : []
                }
            },
            immediate: true
        },
        list_ward: {
            handler(newList) {
                // When ward list is loaded, try to pre-select based on ma_don_vi
                if (newList && newList.length > 0 && this.isRoleEducationOfficeOrSchool) {
                    const user = this.auth_user
                    if (user && user.ma_don_vi) {
                        this.preselectWardFromMaDonVi(user.ma_don_vi)
                    }
                }
            },
            immediate: false
        }
    },
    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        isRoleEducationOfficeOrSchool() {
            return (
                checkUserRole(this.auth_user, ROLES.EducationOffice) ||
                checkUserRole(this.auth_user, ROLES.School)
            )
        },
        isRoleSchool() {
            return checkUserRole(this.auth_user, ROLES.School)
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
.select-all-checkbox {
    accent-color: var(--blue-200);
}
</style>
